import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/budgets',
    name: 'TeamBudgets',
    component: () => import('@/views/OrgBudgets.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pageOrgBudgets.metaTitle',
    },
  },
  {
    path: '/budgets/:budgetTwrn?',
    name: 'TeamBudgetRoster',
    component: () => import('@/views/TeamBudgetRosterView.vue'),
    props: true,
    redirect: { name: 'TeamBudgetRosterView' },
    beforeEnter: (to) => {
      if (!to.params.budgetTwrn) {
        return { name: 'TeamBudgets' };
      }
    },
    meta: {
      layout: 'LayoutAuthenticated',
      layoutOptions: {
        noAppBarBorder: true,
      },
      requiresAuth: true,
      title: 'pageTeamBudgetRoster.metaTitle',
    },
    children: [
      {
        path: 'roster-view',
        name: 'TeamBudgetRosterView',
        component: () => import('@/views/TeamBudgetRoster.vue'),
        props: true,
        meta: {
          layout: 'LayoutAuthenticated',
          requiresAuth: true,
          title: 'pageTeamBudgetRoster.metaTitle',
        },
      },
      {
        path: 'depth-chart',
        name: 'TeamBudgetDepthChart',
        component: () => import('@/views/TeamBudgetDepthChart.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          requiresAuth: true,
          title: 'pageTeamBudgetDepthChart.metaTitle',
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found',
  },
];
export default routes;
